import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../../core/services';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { ListItemDto, ListPayloadDto, ListResponseDto, UpdateListPayload } from '../../dto';

@Injectable({
    providedIn: 'root'
})
export class ListApiService {
    private readonly url: string = 'service/contactcloud/list';
    private readonly pendingVerificationTier: string = this.authenticationService.getPendingTiers()?.toString();

    constructor(
        private readonly authenticationService: AuthenticationService,
        private readonly baseApiService: BaseApiService,
    ) {
    }

    getListsByIds(listIds: number[] | string[]): Observable<ListItemDto[]> {
        return this.baseApiService.post(`${this.url}/fetch-by-ids`, { listIds });
    }

    getListDetails(id, matchOnJobHistory?: boolean): Observable<any> {
        return this.baseApiService.get<any>(`${this.url}/companiesDetails`, {
            params: {
                id,
                ...(typeof matchOnJobHistory === 'boolean' ? { matchOnJobHistory } : {}),
            }
        });
    }

    analyzeCompanyList(listId: number, levelDepartmentPairs): Observable<any> {
        const requestPayload = {
            listId,
            levelDepartmentPairs,
            pendingVerificationTiers: this.pendingVerificationTier,
        };
        return this.baseApiService.post<any>(`${this.url}/analyze`, requestPayload, { showError: true });
    }

    analyzeContactList(listId: number, matchOnJobHistory: boolean): Observable<any> {
        const requestPayload = {
            listId: listId,
            pendingVerificationTiers: this.pendingVerificationTier.toString(),
            matchOnJobHistory: matchOnJobHistory,
        };
        return this.baseApiService.post<any>(`${this.url}/analyzeContacts`, requestPayload);
    }

    analyzeSuppressions(listId: number, matchOnJobHistory: boolean): Observable<any> {
        const requestPayload = {
            listId,
            matchOnJobHistory,
            pendingVerificationTiers: this.pendingVerificationTier.toString(),
        };
        return this.baseApiService.post<any>(`${this.url}/analyzeSuppressions`, requestPayload);
    }

    deleteList(itemId: number): Observable<{ response: string }> {
        return this.baseApiService.delete(`service/contactcloud/list/${itemId}`, { showError: true });
    }

    deleteSuppressionList(data): Observable<{ response: string }> {
        return this.baseApiService.post(`${this.url}/suppression/item`, data);
    }

    deleteListItems(data): Observable<{ response: string }> {
        return this.baseApiService.post(`${this.url}/items`, data, { showError: true });
    }

    getList(listPayload: ListPayloadDto): Observable<ListResponseDto> {
        return this.baseApiService.post<ListResponseDto>(this.url, listPayload, { showError: true });
    }

    getPreviewListByType(type: 'suppression' | 'contact' | 'company', data): Observable<any> {
        return this.baseApiService.post(`${this.url}/preview/${type}`, data, { showError: true });
    }

    updateListsPrivacy(ids: string) {
        return this.baseApiService.post(`service/contactcloud/list/increase-availability`, null, { params: { ids }, showError: true });
    }

    updateList(itemId: number, parameters: UpdateListPayload): Observable<ListItemDto> {
        return this.baseApiService.put(`${this.url}/${itemId}`, parameters);
    }
}
